import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { TASK_STATUS } from '@src/shared/types/task';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';

export const taskStatusFilterConfig = createSimpleFilterConfig({
  facetName: 'status',
  options: Object.values(TASK_STATUS).map((status) => ({
    label: formatTextForDisplay(status),
    value: status,
  })),
});
